


export const TO_DATE = 'toDate';
export const FROM_DATE = 'fromDate';
export const EXCEL_FORMAT_TYPE='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const DEFAULT_TIME='00:00:00';
export const VENDOR_DATA_DEFAULT_FILE_NAME='VendorData';
export const INVALID_DATE_RANGE_MSG="Please enter valid date range, From date should be before To date!!!!!!";
export const INTERNAL_SERVER_ERROR_MSG="Some went wrong !!! please try again later...";
export const BAD_REQUEST_ERROR_MSG="Please select valid date range";
export const EMPTY_RESPONSE_MSG="No vendor data available for selected date range!!! Date range selected =>";